import React from "react";

import { BaseComponent } from "shared/components";

/**
 *
 * @param choices list of choices
 * @param choicesStream should be a promise
 */
function withMultiButtonSelectHOC(choices, choicesStream = undefined, noReset = false) {
    return class extends BaseComponent {
        constructor(props) {
            super(props);

            this.defaultValue = props.value ? props.value : "";
            this.label = props.label ? props.label : "";

            this.state = {
                value: this.defaultValue,
                values: choices,
                noReset: noReset
            };

            this.onChange = this.onChange.bind(this);
            this.resetState = this.resetState.bind(this);
        }

        async componentDidMount() {
            if (choicesStream) {
                await choicesStream((values) => {
                    this.setState({ values });
                });
            }

            const value = this.state.values.find((v) => v.value === this.props.value)?.value;
            await this.setState({ value });
        }

        async componentDidUpdate(prevProps) {
            const { values } = this.state;
            if (this.props.value !== prevProps.value) {
                // find value by value
                const value = values.find((v) => v.value === this.props.value)?.value;
                await this.setState({ value });
            }
        }

        onChange(color) {
            const currentColors = this.props.value;

            if (currentColors.includes(color)) {
                const itemIndex = currentColors.findIndex((cc) => cc === color);
                currentColors.splice(itemIndex, 1);
            } else {
                currentColors.push(color);
            }

            if (this.props.onChange) {
                const name = this.props.name;
                this.props.onChange({
                    target: { name, value: currentColors }
                });
            }
        }

        resetState() {
            if (!this.state.noReset) {
                this.setState({ value: "" });
            }
        }

        render() {
            const { values } = this.state;
            const { value, className } = this.props;

            return (
                <React.Fragment>
                    <label className="label">
                        {this.props.label} <small className="is-size-7">(Multiple)</small>
                    </label>
                    <div className="columns is-multiline is-centered">
                        {values.map((v) => (
                            < div className="column is-4" key={v.label} >
                                <button
                                    type="button"
                                    className={`button ${className} is-fullwidth ${value.includes(v.label) ? "is-link" : ""}`}
                                    data-tooltip={v.label}
                                    onClick={() => this.onChange(v.value)}>{v.label}
                                </button>
                            </div>
                        ))}
                    </div>

                </React.Fragment >
            );
        }
    }
}

export default withMultiButtonSelectHOC;
